<template>
  <div class="side-overflow hide-scrollbar pb-5" :class="{'ml-4':$vuetify.breakpoint.mobile}">
    <v-bottom-sheet 
      v-model="sheet"
      width="100%"
      hide-overlay
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn 
          @click="sheet = true"  
          rounded 
          small 
          class="mx-2" 
          outlined
          v-bind="attrs"
          v-on="on"
          color="primary"
        >
          Médicos <v-icon right>mdi-chevron-down</v-icon>
        </v-btn>
      </template>
      <v-list class="fh-sheet-list overflow-y-auto">
        <v-subheader class="fh-sheet-header">Filtrar médicos<v-spacer></v-spacer><v-btn
          icon
          @click="sheet = !sheet"
        >
          <v-icon >mdi-window-close</v-icon>
        </v-btn>
        </v-subheader>
        <v-list-item >
          <v-chip :disabled="!filtrarMedicos" filter-icon="mdi-notification-clear-all" label small v-model="filtrarMedicos" filter color="primary" @click="filterMedicos = []; filtrarMedicos = false">Mostrar todos</v-chip>
        </v-list-item>
        <v-list-item
          v-for="(medico,m) in listaMedicos" 
          :key="m"
        >
          <v-checkbox 
            v-model="filterMedicos" 
            hide-details="auto" 
            class="mt-0 pt-0"
            dense
            :label="medico.medico" 
            :value="medico.idMedico"
          ></v-checkbox>
        </v-list-item>
      </v-list>
    </v-bottom-sheet>
    <v-menu>
      <template v-slot:activator="{ on }">
        <v-btn v-on="on" rounded small color="primary" class="mx-2" outlined>
          Fechas <v-icon right>mdi-chevron-down</v-icon>
        </v-btn>
      </template>
      <v-date-picker
        v-model="filterFechas"
        :events="turnos"
        event-color="green lighten-1"
        multiple
        :allowed-dates="allowedDates"
        first-day-of-week="1"
        :min="listaFechas[0]"
        :max="listaFechas[listaFechas.length-1]"
      ></v-date-picker>
    </v-menu>
    <v-btn :disabled="filterMedicos.length === 0 && filterFechas.length === 0" small rounded color="primary" @click="filterMedicos = []; filterFechas = [];">
      Ver todos 
      <v-icon
        right
        v-if="filterMedicos.length !== 0 || filterFechas.length !== 0"
      >
        mdi-check
      </v-icon>
    </v-btn>
    <!-- <v-chip filter-icon="mdi-notification-clear-all"  small v-model="filtrar" filter color="primary" @click="filterMedicos = []; filterFechas = []; filtrar = false">Mostrar todos</v-chip> -->

  </div>
</template>
 
<script>
  import {mapState,mapActions} from 'vuex'

  export default {
    data: () =>({
      sheet: false,
      fecha: null,
      filterMedicos: [],
      filterFechas: [],
      filtrarMedicos: false,
      filtrarFechas: false,
    }),
    watch: {
      filterMedicos(){
        this.setMedicoFilters(this.filterMedicos)
        if(this.filterMedicos.length !== 0){
          this.filtrarMedicos = true
        }
      },
      filterFechas(){
        this.setFechaFilters(this.filterFechas)
        if(this.filterFechas.length !== 0){
          this.filtrarFechas = true
        }
      }
    },
    computed: {
      ...mapState('turnos',[
        'listaTurnos',
        'listaMedicos',
        'listaMisTurnos',
        'listaFechas'
      ]),
      turnos(){
        let misTurnos =  []
        misTurnos = this.listaMisTurnos.map(turno => turno.event.start.toISOString().substr(0,10))
        return misTurnos
      }
    },
    methods: {
      ...mapActions('turnos',[
        'setMedicoFilters',
        'setFechaFilters'
      ]),
      allowedDates(val){
        return this.listaFechas.includes(val)
      }
    },
  }
</script>

<style scoped>
.side-overflow {
  overflow-x: auto;
  display: flex;
  align-items: center;
}
.fh-sheet-list {
  max-height: 80vh;
  background-color: #fff;
}
.fh-sheet-header {
  position: sticky;
  top: 0;
  z-index: 1;
  background-color: #fff;
}
.hide-scrollbar::-webkit-scrollbar {
  display: none;
}
.fh-btn-btg.v-btn--outlined {
  border: thin solid black;
  background-image: linear-gradient(to bottom right, #1F3B76, #009a4e);
}

.fh-btn-gtb.v-btn--outlined {
  border: thin solid black;
  background-image: linear-gradient(to bottom right, #009a4e, #1F3B76);
}
</style>
